var exports = {
  "kL": "xdbfd91f1--09d84d--container",
  "VD": "xdbfd91f1--09d84d--container--mortgage-annotations",
  "Qs": "xdbfd91f1--09d84d--content",
  "Hs": "xdbfd91f1--09d84d--photo-block",
  "sf": "xdbfd91f1--09d84d--main-content-block",
  "cn": "xdbfd91f1--09d84d--photo-label",
  "UJ": "xdbfd91f1--09d84d--content-container",
  "Dn": "xdbfd91f1--09d84d--transports-container",
  "X": "xdbfd91f1--09d84d--ad-info",
  "Eq": "xdbfd91f1--09d84d--builder-name-wrapper",
  "RJ": "xdbfd91f1--09d84d--description-wrapper",
  "Ie": "xdbfd91f1--09d84d--empty",
  "PM": "xdbfd91f1--09d84d--close-block",
  "YB": "xdbfd91f1--09d84d--mortgage-annotations",
};

module.exports = exports;
